class d {
  isValid = !1;
  provider = "";
  id = "";
}
const a = [
  {
    provider: "youtube",
    regex: /^(?:https?:\/\/)?(?:www\.)?(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))([\w-]{11})(?:\S+)?$/
  },
  {
    provider: "youtube",
    regex: /^(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/shorts\/)([\w-]{11})(?:\S+)?$/
  },
  {
    provider: "vimeo",
    regex: /vimeo\..*?\/(\d+)\/([\w-]+)/i
  },
  {
    provider: "vimeo",
    regex: /vimeo\..*?\/(\d+)\?h=([\w-]+)/i
  },
  {
    provider: "vimeo",
    regex: /vimeo\..*?\/(\d+)(?:\/)?/i
  },
  {
    provider: "wistia",
    regex: /wistia\..*\/([^?]+)\??.*/i
  },
  {
    provider: "loom",
    regex: /(?:use)?loom\..*\/([^?]+)\??.*/i
  },
  {
    provider: "vidyard",
    regex: /vidyard\..*\/([^?]+)\??.*/i
  },
  {
    provider: "brightcove",
    regex: /players\.brightcove\.net\/([^/]+)\/.*videoId=([\w-]+)/i
  },
  {
    provider: "jwplayer",
    regex: /(?:cdn|content)\.jwplatform\.com\/players\/([\w-]+)\.html/i
  },
  {
    provider: "microsoftstream",
    regex: /web\.microsoftstream\.com\/embed\/video\/([\w-]+)/i
  },
  {
    provider: "microsoftstream",
    regex: /^(?:https?:\/\/)?([\w-]+)\.sharepoint\.com\/:v:\/(.*)/i
  },
  {
    provider: "synthesia",
    regex: /share\.synthesia\.io\/embeds\/videos\/([\w-]+)/i
  },
  {
    provider: "synthesia",
    regex: /share\.synthesia\.io\/([\w-]+)/i
  },
  {
    provider: "guidde",
    regex: /embed\.app\.guidde\.com\/playbooks\/([\w-]+)/i
  },
  {
    provider: "descript",
    regex: /share\.descript\.com\/(?:embed|view)\/([\w-]+)/i
  },
  {
    provider: "guideflow",
    regex: /app\.guideflow\.com\/(?:embed|video|player)\/([\w-]+)/i
  },
  {
    provider: "supademo-showcase",
    regex: /app\.supademo\.com\/showcase\/embed\/([\w-]+)/i
  },
  {
    provider: "supademo-showcase",
    regex: /app\.supademo\.com\/showcase\/([\w-]+)/i
  },
  {
    provider: "supademo",
    regex: /app\.supademo\.com\/embed\/([\w-]+)/i
  },
  {
    provider: "supademo",
    regex: /supademo\.com\/demo\/([\w-]+)/i
  },
  {
    provider: "arcade",
    regex: /app\.arcade\.software\/share\/([\w-]+)/i
  },
  {
    provider: "arcade",
    regex: /demo\.arcade\.software\/([\w-]+)/i
  },
  {
    provider: "supercut",
    regex: /supercut\.video\/share\/([\w-]+)\/([\w-]+)/i
  },
  {
    provider: "supercut",
    regex: /supercut\.ai\/share\/([\w-]+)\/([\w-]+)/i
  },
  {
    provider: "supercut",
    regex: /supercut\.ai\/embed\/([\w-]+)\/([\w-]+)/i
  }
], s = "|";
function p(o) {
  const t = new d();
  return o && (o = o.trim(), a.some((e) => {
    const r = o.match(e.regex);
    if (r) {
      const [, ...i] = r;
      return t.provider = e.provider, t.id = i.join(s), t.isValid = !0, !0;
    } else
      return !1;
  })), t;
}
function m(o, t) {
  const [e, ...r] = t.split(s);
  switch (o) {
    case "youtube":
      return `https://www.youtube.com/embed/${e}?rel=0`;
    case "vimeo":
      return r.length === 0 ? `https://player.vimeo.com/video/${e}` : `https://player.vimeo.com/video/${e}?h=${r[0]}`;
    case "wistia":
      return `https://fast.wistia.net/embed/iframe/${e}`;
    case "loom":
      return `https://www.loom.com/embed/${e}`;
    case "vidyard":
      return `https://play.vidyard.com/${e}`;
    case "brightcove":
      return `https://players.brightcove.net/${e}/default_default/index.html?videoId=${r[0]}`;
    case "jwplayer":
      return `https://content.jwplatform.com/players/${e}.html`;
    case "microsoftstream":
      return r.length === 0 ? `https://web.microsoftstream.com/embed/video/${e}` : `https://${e}.sharepoint.com/:v:/${r[0]}`;
    case "synthesia":
      return `https://share.synthesia.io/embeds/videos/${e}`;
    case "guidde":
      return `https://embed.app.guidde.com/playbooks/${e}`;
    case "descript":
      return `https://share.descript.com/embed/${e}`;
    case "guideflow":
      return `https://app.guideflow.com/embed/${e}`;
    case "supademo":
      return `https://app.supademo.com/embed/${e}`;
    case "supademo-showcase":
      return `https://app.supademo.com/showcase/embed/${e}`;
    case "arcade":
      return `https://demo.arcade.software/${e}?embed`;
    case "supercut":
      return `https://supercut.ai/embed/${e}/${r[0]}`;
    default:
      throw new Error(`Video provider ${o} not supported`);
  }
}
export {
  m as generateVideoUrl,
  p as parseUrl
};
